// ©2024 Austin App House. All rights reserved.
import './instrument';
import React from 'react';
import ReactDOM from 'react-dom';
// import './index.css';

// import '@fortawesome/fontawesome-free/css/all.min.css';
// import 'bootstrap-css-only/css/bootstrap.min.css';
// import 'mdbreact/dist/css/mdb.css';
import "react-datepicker/dist/react-datepicker.css";
import App from './App';
import * as serviceWorker from './serviceWorker';
import {Provider} from "react-redux";
import store from "./storage/store";
import 'react-quill/dist/quill.snow.css';

if (typeof window !== 'undefined' && process.env.REACT_APP_API_BASE_URL) {
  window.__WURQLY_API_BASE__ = process.env.REACT_APP_API_BASE_URL;
}

ReactDOM.render(<Provider store={store}><App /></Provider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
